import { createAuthenticatedAxios } from "../../helpers/axiosClient"

/**
 * Cliente axios para el admin API (ser.ls-da.com/admin/api/*).
 * Usa createAuthenticatedAxios que ya incluye:
 *  - Bearer token automático desde localStorage.authUser.accessToken
 *  - Refresh de accessToken en 401 con cola de requests
 *  - Logout y redirect en 403 o refresh fallido
 *
 * baseURL viene de REACT_APP_API_URL (https://ser.ls-da.com/admin/api/)
 */
const adminClient = createAuthenticatedAxios(process.env.REACT_APP_API_URL)

export default adminClient
